import React from 'react';

const ITMetrics = ({ 
    title = "IT RECRUITMENT IMPACT METRICS", 
    metrics = [] 
}) => {
    return (
        <section className="py-24 bg-white overflow-hidden">
            <div className="container mx-auto px-6">
                <div className="flex flex-col lg:flex-row items-center gap-20">
                    <div className="lg:w-1/3">
                        <h2 className="text-4xl md:text-5xl font-bold text-slate-900 syne mb-8 leading-tight">
                            Recruitment <br/> Impact <span className="text-blue-600">Metrics</span>
                        </h2>
                        <p className="text-slate-500 text-lg">
                            {title}
                        </p>
                    </div>
                    <div className="lg:w-2/3 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 w-full">
                        {metrics && metrics.map((m, i) => (
                            <div key={i} className="p-6 bg-blue-50/20 rounded-3xl border-l-4 border-blue-600 border border-blue-100/50 flex flex-col justify-between shadow-sm hover:shadow-md transition-shadow">
                                <h4 className="text-lg font-black text-slate-900 mb-2 leading-tight">{m.title}</h4>
                                <p className="text-slate-500 text-xs leading-relaxed">{m.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ITMetrics;